export default __webpack_public_path__ + "static/media/qapitol.ff8d1eb6.webp";